import * as Yup from 'yup';

export const SITE_DETAILS_TABS = [
  'address',
  'contact',
  'fulfilment',
  'linked-buyer-sites',
  'linked-users',
] as const;
export type SiteDetailsTab = (typeof SITE_DETAILS_TABS)[number];

export const DistributorSiteDetailsSearchParamsSchema = Yup.object({
  tab: Yup.mixed<SiteDetailsTab>()
    .oneOf([...SITE_DETAILS_TABS])
    .optional()
    .default('address'),
});
